import React from 'react';
import {SVGModel} from '../../../framework.visual/model/svgModel';

export const ArrowDownSVG = ({className} : SVGModel) => (
    <svg className={className} viewBox="0 0 32 32">
        <path d="M 7.997283,16 0,7.9972826 H 16 32 L 24.002718,16 C 19.604212,20.401495 16.002989,24.002717 16,24.002717 15.997,24.002717 12.395788,20.401495 7.997283,16 Z"/>
    </svg>
);


